import {useSearchParams} from 'react-router-dom';
import {signInWithRedirect} from 'aws-amplify/auth';
import {useUserAttributes} from '../hooks/useUserAttributes';
import {UserLayout} from './UserLayout';
import {PublicLayout} from './PublicLayout';

// Auth-aware layout switcher. Mirrors the bot/email pattern: read `email`
// from UserAttributesProvider and pick UserLayout (with sidebar nav) or
// PublicLayout (no sidebar) accordingly.
//
// The `?next=authn` query param triggers Cognito hosted-UI sign-in
// automatically — used by cross-property links that want to land the user
// on a specific page after authentication. Anonymous visitors fall through
// to PublicLayout.
export const AppLayout = () => {
    const [searchParams] = useSearchParams();
    const next = searchParams.get('next');

    const {email} = useUserAttributes();

    if (email) {
        return <UserLayout />;
    }

    if (next === 'authn') {
        signInWithRedirect();
    }

    return <PublicLayout />;
};
